/*
 * @Author: wzh
 * @LastEditTime: 2024-11-29 15:22:21
 * @Description: PC端 防遗忘等页面公共方法
 */
import * as CryptoJS from "crypto-js"; // base64解密
import { mapGetters } from "vuex";

export const commonMethods = {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("auth", ["user", "token"]),
  },
  methods: {
    getCookieDomain() {
      const host = window.location.hostname || "";
      const isIpv4 = /^(\d{1,3}\.){3}\d{1,3}$/.test(host);
      if (!host || host === "localhost" || isIpv4 || host.indexOf(".") === -1) {
        return "";
      }
      const parts = host.split(".");
      if (parts.length <= 2) {
        return `.${host}`;
      }
      return `.${parts.slice(-2).join(".")}`;
    },
    setLoginCookies(token, user) {
      if (!token) return;
      const rememberMe = this.$cookies.get("REMEMBER_ME");
      const rememberMeToken = rememberMe && rememberMe.token;
      const isRememberMe = rememberMeToken && rememberMeToken === token;
      const domain = this.getCookieDomain();
      const domainPart = domain ? `; domain=${domain}` : "";
      // 先清理 host/domain 下历史同名 cookie，避免出现两个 congress
      document.cookie = `congress=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      if (domain) {
        document.cookie = `congress=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      }
      const maxAgePart = isRememberMe ? `; max-age=${7 * 24 * 60 * 60}` : "";
      document.cookie = `congress=${encodeURIComponent(
        token
      )}; path=/${domainPart}${maxAgePart}; SameSite=Lax`;
      document.cookie = `token=${encodeURIComponent(token)}; path=/${domainPart}; SameSite=Lax`;
      const encodedUser = encodeURIComponent(JSON.stringify(user || {}));
      document.cookie = `user=${encodedUser}; path=/${domainPart}; SameSite=Lax`;
    },
    // base64解码
    // getBase64(redirect_uri) {
    //   let url = CryptoJS.enc.Base64url.parse(redirect_uri).toString(CryptoJS.enc.Utf8);
    //   return window.decodeURIComponent(url);
    // },
    getBase64(base64) {
      try {
        const decodedBase64Url = decodeURIComponent(base64);
        const url = atob(decodedBase64Url);
        return url;
      } catch (error) {
        // 错误处理
        console.error(
          "An error occurred during Base64 to URL decoding:",
          error
        );
        return null;
      }
    },
    // 返回登录
    goLogin() {
      let language = localStorage.getItem("language");
      localStorage.clear();
      if (language) {
        localStorage.setItem("language", language);
      }
      sessionStorage.clear();
      this.$router.replace({ path: "/mlogin" });
    },
    // 判断下一步操作
    jumpComputed() {
      let redirect_uri = sessionStorage.getItem("REDIRECT_URI");
      let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
      if (before_login.noSingleLogin) {
        this.$router.replace({ path: "/msimplyLogin" });
      } else if ("1,2,3".includes(before_login.editPwd)) {
        this.$router.replace({ path: "/mupdatePassword" });
      } else if (before_login.showInfo) {
        this.$router.replace({ path: "/mperfectInfo" });
      } else if (before_login.userInfoConfim) {
        this.$router.replace({ path: "/mforgotten" });
      } else if (before_login.secAuth) {
        this.$router.replace({ path: "/msecondAuth" });
      } else {
        sessionStorage.removeItem("BEFORE_LOGIN");
        this.setLoginCookies(this.token, this.user);
        if (redirect_uri) {
          let url = this.getBase64(redirect_uri);
          location.href = url;
        } else {
          this.$router.replace({ path: "/mAuthServer" });
        }
      }
    },
  },
};
